import get from 'lodash/get';
import React, { useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { StyleSheet, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import fetchTranslations from '../../common/actions/fetchTranslations';
import defaultTranslations from './translations';
import isEmpty from 'lodash/isEmpty';
const translationsKey = 'support-center';

const styles = StyleSheet.create({
  loading: {
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: 20
  }
});
export function IntlWrapper({ children, locale }) {
  const dispatch = useDispatch();
  const { translations, translationsLoading } = useSelector(state => {
    return {
      translations: get(state, `translationsReducer.translations.data.${translationsKey}`, defaultTranslations),
      translationsLoading: get(state, 'translationsReducer.translations.isFetching')
    };
  });
  useEffect(() => {
    if (isEmpty(translations) && !translationsLoading) {
      dispatch(
        fetchTranslations({
          features: translationsKey,
          defaultTranslations: {
            [translationsKey]: defaultTranslations
          }
        })
      );
    }
  });
 return translationsLoading ? (
    <View style={styles.loading}>{/* <BlockingLoader /> */}</View>
  ) : (
    <IntlProvider locale={locale} messages={translations}>
      {children}
    </IntlProvider>
  );
}
